import './style.modules.css'
import { useEffect, useRef, useState } from 'react'
import { Collapse, Button, IconButton, MenuItem, Select, Menu } from '@mui/material'
import { GridColDef, GridRowsProp, GridValidRowModel } from '@mui/x-data-grid'
import { SectionContainer } from '../../../../components/SectionContainer/SectionContainer'
import { useClient } from '../../../../contexts/ClientContext'
import styles from './RegisterationStage.module.css'
import { CustomerDataGrid, ptBRLocaleText } from './style'
import chatApi from '@/services/api/chat'
import { formataDate } from '@/utils/formatDate'

import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import HourglassTopOutlinedIcon from '@mui/icons-material/HourglassTopOutlined';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import AddIcon from '@mui/icons-material/Add'
import attendanceApi from '@/services/api/attendance'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

interface RegistrationProps {
  expanded: boolean
  setExpanded: (expanded: boolean) => void
  onRegisterClick: () => void
}

export function RegistrationStage({
  expanded,
  setExpanded,
  onRegisterClick,
}: RegistrationProps) {
  const toggleExpanded = () => {
    setExpanded(!expanded)
  }
  const [rows, setRows] = useState<GridRowsProp>([])
  const [activeSessions, setActiveSessions] = useState<Record<string, boolean>>(
    {}
  ) // Armazenar sessões ativas
  const [filtro, setFiltro] = useState<string>('Nome')
  const [campoFiltro, setCampoFiltro] = useState<string>('')

  const menuRef = useRef<HTMLDivElement>(null);
  const [menuOpcao, setMenuOpcao] = useState<null | HTMLElement>(null);
  const [listaArquivado, setListaArquivado] = useState<boolean>(false)
  const [atualizarLista, setAtualizarLista] = useState<boolean>(false)
  const [atendimentoSelecionadoId, setAtendimentoSelecionadoId] = useState<number>()

  const clientContext = useClient()

  function handleCadastro() {
    onRegisterClick()
    clientContext.resetClient()
  }

  function alteraOpcao(e: React.MouseEvent<HTMLButtonElement>) {
    setMenuOpcao(menuOpcao ? null : e.currentTarget);
  }

  function fechaMenuOpcao() {
    setMenuOpcao(null);
  }

  useEffect(() => {
    const alteraOpcao = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        fechaMenuOpcao();
      }
    };
    document.addEventListener('mousedown', alteraOpcao);
    return () => document.removeEventListener('mousedown', alteraOpcao);
  }, []);

  useEffect(() => {
    try {
      clientContext.reloadClientes()
    } catch (err) {
      console.log(err)
    }
  }, [])

  async function arquivar(id?: number) {
    try {
      if (listaArquivado) {
        await attendanceApi.atualizarArquivamento(id, false)
      } else {
        await attendanceApi.atualizarArquivamento(id, true)
      }

      setAtualizarLista(!atualizarLista)
    } catch (err) {
      console.log('Erro ao arquivar')
    }
    fechaMenuOpcao()
  }

  async function deletar(id?: number) {
    fechaMenuOpcao()
  }

  useEffect(() => {
    const checkActiveSessions = async (clients: any[]) => {
      const sessions = await Promise.all(
        clients.map(async (client) => {
          const phone = client.Client.dadosPessoais.telefone
          try {
            const response = await chatApi.userActiveSession(phone)
            return { phone, isActive: response.data.open }
          } catch (error) {
            console.error(
              `Erro ao verificar sessão do telefone ${phone}:`,
              error
            )
            return { phone, isActive: false }
          }
        })
      )

      const sessionMap: Record<string, boolean> = {}
      sessions.forEach((session) => {
        sessionMap[session.phone] = session.isActive
      })

      setActiveSessions(sessionMap)
    }

    if (clientContext.clientes.length > 0) {
      checkActiveSessions(clientContext.clientes)
    }
  }, [clientContext.clientes])

  const columns: GridColDef[] = [
    { field: 'currentService', headerName: "Nº", minWidth: 50, flex:1},
    { field: 'name', headerName: 'CLIENTES', minWidth: 160, flex: 1 },
    {
      field: 'number',
      headerName: 'TELEFONE',
      minWidth: 150,
      cellClassName: styles.tell,
      flex: 1,
      renderCell: (params) => {
        const phone = params.value
        const isActive = activeSessions[phone]
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ChatBubbleIcon
              style={{ marginRight: 8, fontSize: '1rem' }}
              className={isActive ? styles.icon_active : styles.icon_disabled}
            />
            {params.value}
          </div>
        )
      },
    },
    {
      field: 'state',
      headerName: 'STATUS',
      minWidth: 100,
      flex: 1,
      renderCell: (params) => {
        let appliedStyle = ''

        switch (params.value) {
          case 'Proposta':
            appliedStyle = styles.statusProposta
            break
          case 'Produção':
            appliedStyle = styles.statusProducao
            break
          case 'Briefing':
            appliedStyle = styles.statusBriefing
            break
          case 'Feedback':
          case 'Montagem':
            appliedStyle = styles.statusFeedback
            break
          default:
            appliedStyle = styles.statusDefault // Define um estilo padrão se necessário
            break
        }

        return (
          <span className={`${appliedStyle} ${styles.status}`}>
            {params.value ?? ''}
          </span>
        )
      },
    },
    {
      field: 'temp',
      headerName: 'TEMPO',
      minWidth: 100,
      flex: 1,
      renderCell: (params) => {

        return (
          <div className={styles.tempo}>
            <HourglassTopOutlinedIcon />
            {params.value.display}
          </div>
        )
      },
      // Agora, vamos filtrar pelo campo "value" numérico
      sortComparator: (v1, v2) => v1.value - v2.value,
      filterable: true,
    },
    {
      field: 'opcao',
      headerName: '',
      flex: 1,
      renderCell: () => {
        return (
          <>
            <div>
              <Button onClick={alteraOpcao} className={styles.opcao}>
                <MoreVertIcon style={{ color: '#4C4E64' }} />
              </Button>

              <Menu
                anchorEl={menuOpcao}
                open={Boolean(menuOpcao)}
                onClose={fechaMenuOpcao}
                ref={menuRef}
                PaperProps={{
                  sx: {
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
                    borderRadius: '8px',
                    marginTop: '1.8rem',
                    marginLeft: '1.4rem',

                  }
                }}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <MenuItem className={styles.opcao_selecionar} onClick={() => { arquivar(atendimentoSelecionadoId) }}>
                  <Inventory2OutlinedIcon />
                  {listaArquivado ? 'Desarquivar' : 'Arquivar'}
                </MenuItem>
                <MenuItem className={styles.opcao_selecionar} onClick={() => { deletar() }}>
                  <DeleteOutlineOutlinedIcon />
                  Deletar
                </MenuItem>
              </Menu>
            </div >
          </>
        )
      },
    }
  ]

  async function filtrarPorClientes() {
    const clientsRow: GridValidRowModel[] = clientContext.clientes.map(
      (client: any, index: number) => {
        return {
          id: index,
          currentService: client.Client.atendimentoAtualId,
          name: client.Client.dadosPessoais.nome || '',
          number: client.Client.dadosPessoais.telefone || '',
          state: client.state || '',
          temp: formataDate(client.atendimentoCriadoEm),
          Client: client.Client,
        }
      }
    )
    setRows(clientsRow)
  }

  useEffect(() => {
    filtrarPorClientes()
  }, [clientContext.clientes])

  useEffect(() => {
    clientContext.reloadClientes(filtro, campoFiltro, listaArquivado)
    filtrarPorClientes()
  }, [campoFiltro, listaArquivado, atualizarLista])

  useEffect(() => {
    setAtendimentoSelecionadoId(clientContext.client.atendimentoAtualId)
  }, [])


  function handleRowClick(params: any) {
    console.log('Linha clicada:', params.row)
    const phone = params.row.number
    const isActive = activeSessions[phone]
    const chatLink = isActive
      ? `https://admin.vivamoveis.com/app/communication?number=${phone}`
      : null

    clientContext.resetClient()
    clientContext.setClient({
      ...params.row.Client,
      atendimentoAtualId: params.row.Client.atendimentoAtualId,
      chatLink: chatLink,
    })
    setAtendimentoSelecionadoId(params.row.Client.atendimentoAtualId)
  }

  function listaAtendimentosArquivados() {
    setListaArquivado(!listaArquivado)
  }

  return (
    <div
      className={
        !expanded ? styles.registration_stage_closed : styles.registration_stage
      }
    >
      <IconButton
        onClick={toggleExpanded}
        className={expanded ? 'Icon-for-closed' : 'Icon-for-open'}
      >
        {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </IconButton>
      <Collapse
        in={expanded}
        timeout={0}
        unmountOnExit
        style={{ overflow: 'hidden' }}
      >
        <h3 className='title-table'>{listaArquivado ? 'Atendimentos Arquivados' : 'Atendimentos'}</h3>
        <SectionContainer className={styles.container_tabela}>
          <div className={styles.header_com_botoes}>
            <Button
              variant='contained'
              disableElevation
              className={styles.botao_cadastro}
              onClick={handleCadastro}
              sx={{
                minWidth: '0',
              }}
            >
              <AddIcon />
              Cadastro
            </Button>

            <div className={styles.opcoes_lista_atendimentos}>
              <div className={styles.filtro_atendimento} >
                <Select
                  value={filtro}
                  onChange={(e) => setFiltro(e.target.value as string)}
                  sx={{
                    height: '2.4rem',
                    border: '1px solid #4C4E6480',
                    borderRadius: '8px 0 0 8px',
                    backgroundColor: '#FAFAFA',
                    color: '#4C4E64',
                    width: '100%',

                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },

                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: '1px solid #666CFF',
                    }

                  }}
                  renderValue={(selected) => <span>{selected}</span>}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        mt: 1,
                        width: 'auto',
                      },
                    },
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                    transformOrigin: {
                      vertical: 'top',
                      horizontal: 'left',
                    },
                  }}
                >
                  <MenuItem
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '16.5rem',
                      color: filtro === 'Nome' ? '#666CFF' : 'inherit', // Define a cor condicionalmente
                    }}
                    value='Nome'
                  >
                    <span>Nome</span>
                    {
                      filtro === 'Nome' ? <CheckCircleOutlineIcon /> : ''
                    }
                  </MenuItem>
                  <MenuItem
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '16.5rem',
                      color: filtro === 'Telefone' ? '#666CFF' : 'inherit', // Define a cor condicionalmente
                    }}
                    value='Telefone'
                  >
                    <span>Telefone</span>
                    {
                      filtro === 'Telefone' ? <CheckCircleOutlineIcon /> : ''
                    }
                  </MenuItem>
                </Select>
                <input
                  type="text"
                  placeholder={filtro === 'Nome' ? 'Buscar por nomes' : 'Buscar por telefone'}
                  value={campoFiltro}
                  onChange={(e) => setCampoFiltro(e.target.value)}
                />
              </div>

              <div className={styles.opcoes_lista_atendimentos}>
                <IconButton onClick={listaAtendimentosArquivados}>
                  <Inventory2OutlinedIcon sx={{
                    color: listaArquivado ? '#666CFF' : '#4C4E64',
                  }} />
                </IconButton>

                <IconButton onClick={toggleExpanded} className='icon-for-closed'>
                  {expanded ? (
                    <ExpandLessIcon fontSize='large' />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </IconButton>
              </div>
            </div>

          </div>
          {rows.length !== 0 ? (
            <CustomerDataGrid
              columns={columns}
              rows={rows}
              className={styles.data_grid}
              localeText={{
                ...ptBRLocaleText,
              }}
              onRowClick={handleRowClick}
              initialState={{
                sorting: {
                  sortModel: [{ field: 'temp', sort: 'asc' }],
                }
              }}
              getRowClassName={() =>
                listaArquivado ? ` ${styles.lista_arquivada}` : ''
              }
            />
          ) : (
            <CustomerDataGrid
              columns={columns}
              className={styles.data_grid_null}
              localeText={{
                ...ptBRLocaleText,
              }}
              hideFooter
              style={{
                overflow: 'visible',
                minHeight: '110px',
              }}
            />
          )}
        </SectionContainer>
      </Collapse>
    </div >
  )
}
